
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import Dialog from '@/components/dialog.vue';
  import {
    ordergetOrderNoByExpressNo
  } from "@/api/order"
	import {
		handleClipboard
	} from '@/utils/clipboard'
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog':Dialog,
    }
  })

  export default class ProductList extends Vue {
    @Prop() show:boolean
    private dialogShow = false
    private keywords = ''
    private result = ''
    private isSearch = false
    @Watch('show')
    private watchShow(val){
      this.dialogShow = val
    }


    private tocopy(e){
      handleClipboard(this.result,e)
    }
    private async search(){
      if(!this.keywords){
        this.$message.error('请先输入要查询的物流单号')
        return 
      }
      try{
        let res = await ordergetOrderNoByExpressNo({
          ExpressNo:this.keywords
        })
        if(res.IsSuccess){
          this.isSearch = true
          this.result = res.Message
        }
      }finally{
        //
      }
    }
    private close(){
      this.dialogShow = false
      this.keywords = ''
      this.result = ''
      this.isSearch = false
      this.$emit('close',false)
    }
  }
